import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const WHATSAPP_NUMBER = '34658402605';

const MESSAGES = {
  home: '¡Hola! Me gustaría consultar sobre un tatuaje en Daro Tattoo 🎨',
  gallery: '¡Hola! He visto vuestra galería y me gustaría más información sobre un diseño 🖼️',
  contact: '¡Hola! Quiero hacer una consulta sobre vuestros servicios de tatuaje 💬',
  legal: '¡Hola! Tengo una consulta sobre vuestros servicios 📋',
  default: '¡Hola! Me gustaría consultar sobre un tatuaje en Daro Tattoo 🎨'
};

export default function WhatsAppButton() {
  const [isVisible, setIsVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [hasShownTooltip, setHasShownTooltip] = useState(false);
  const location = useLocation();

  const getMessage = () => {
    const path = location.pathname;
    if (path === '/') return MESSAGES.home;
    if (path.includes('galeria')) return MESSAGES.gallery;
    if (path.includes('contacto')) return MESSAGES.contact;
    if (path.includes('politica')) return MESSAGES.legal;
    return MESSAGES.default;
  };

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 1500);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (isVisible && !hasShownTooltip) {
      const tooltipTimer = setTimeout(() => {
        setShowTooltip(true);
        setHasShownTooltip(true);
        setTimeout(() => setShowTooltip(false), 4000);
      }, 3000);
      return () => clearTimeout(tooltipTimer);
    }
  }, [isVisible, hasShownTooltip]);

  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(getMessage())}`;

  return (
    <div
      className={`fixed bottom-6 left-6 z-50 flex items-end gap-3 transition-all duration-500 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
      }`}
    >
      {/* Button */}
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer nofollow"
        className="group relative w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg shadow-[#25D366]/30 hover:shadow-xl hover:shadow-[#25D366]/40 hover:scale-110 transition-all duration-300 cursor-pointer"
        aria-label="Contactar por WhatsApp"
        onMouseEnter={() => { if (!showTooltip) setShowTooltip(true); }}
        onMouseLeave={() => setShowTooltip(false)}
      >
        <i className="ri-whatsapp-line text-white text-2xl"></i>
        {/* Pulse ring */}
        <span className="absolute inset-0 rounded-full bg-[#25D366]/40 animate-ping"></span>
      </a>

      {/* Tooltip */}
      <div
        className={`bg-white rounded-xl shadow-2xl px-4 py-3 max-w-[220px] transition-all duration-300 ${
          showTooltip ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-4 pointer-events-none'
        }`}
      >
        <button
          onClick={() => setShowTooltip(false)}
          className="absolute -top-2 -left-2 w-5 h-5 bg-neutral-200 rounded-full flex items-center justify-center text-neutral-500 hover:bg-neutral-300 transition-colors cursor-pointer text-xs"
        >
          <i className="ri-close-line"></i>
        </button>
        <p className="text-neutral-800 text-sm font-medium leading-snug">
          ¿Tienes dudas? Escríbenos por WhatsApp 💬
        </p>
        <div className="absolute left-[-6px] bottom-5 w-3 h-3 bg-white rotate-45 shadow-sm"></div>
      </div>
    </div>
  );
}

export { WHATSAPP_NUMBER };
